var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_html.js
// module id = q11y
// module chunks = 15